<template>
  <section>
    <!--工具条-->
    <ShiftToolbar :buttonList="buttonList" @callFunction="callFunction"></ShiftToolbar>

    <!--列表-->
    <el-table
      :data="shiftList"
      highlight-current-row
      v-loading="listLoading"
      @current-change="selectCurrentRow"
      @selection-change="handleSelectionChange"
      style="width: 100%;"
    >
      <el-table-column
        type="selection"
        width="55">
      </el-table-column>
      <el-table-column fixed="left" type="index" label="序号" width="60"></el-table-column>
      <el-table-column
        fixed="left"
        label="操作"
        width="170">
        <template slot-scope="scope">
          <span v-for="item in operationButtonList" :key="item.id">
            <el-button type="text" style="padding-right:6px;" size="small" v-if="!item.IsHide" @click="operationButtonFunction(item,scope.row)">{{item.name}}</el-button>
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="LineName" label="线路" width="90" sortable></el-table-column>
      <el-table-column prop="DepartureTemplate" label="发车模版" width="120" sortable></el-table-column>
      <el-table-column prop="ClassName" label="班别" width="90" sortable></el-table-column>
      <el-table-column prop="ShiftName" label="班次" width="90" :sort-by="['PositionSerial']" sortable></el-table-column>
      <el-table-column prop="DriverName" label="挂班司机" width="110" sortable></el-table-column>
      <el-table-column prop="VehicleName" label="挂班车辆" width="110" sortable></el-table-column>
          
      <el-table-column prop="LineMode" label="运行模式" width="110" sortable></el-table-column>
      <el-table-column
        label="上行计划发车时间"
        width="300">
        <template slot-scope="scope">
          <span v-for="item in scope.row.DepartureTime" :key="item.id">
            <el-button type="text" style="padding-right:6px;font-size:18px;" size="small" v-if="(scope.row.LineMode==='上下行' && item.RunningDirection === '上行') || scope.row.LineMode==='环行'" @click="handleDepartureTimeEdit(item,scope.row.LineMode)">{{item.DepartureTimeStr}}</el-button>
          </span>
        </template>
      </el-table-column>
      <el-table-column
        label="下行计划发车时间"
        width="300">
        <template slot-scope="scope">
          <span v-for="item in scope.row.DepartureTime" :key="item.id">
            <el-button type="text" style="padding-right:6px;font-size:18px;" size="small" v-if="scope.row.LineMode==='上下行' && item.RunningDirection === '下行'" @click="handleDepartureTimeEdit(item,scope.row.LineMode)">{{item.DepartureTimeStr}}</el-button>
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="StartSite" label="起始站点" width="115" sortable></el-table-column>
      <el-table-column prop="EndSite" label="结束站点" width="115" sortable></el-table-column>
      <el-table-column prop="ReplaceDriverName" label="顶班司机" width="110" sortable></el-table-column>
      <el-table-column prop="ReplaceVehicleName" label="顶班车辆" width="110" sortable></el-table-column>
      <el-table-column prop="FirstReplaceDateString" label="首次顶班时间" width="130" sortable></el-table-column> 
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination
        layout="total, sizes, prev, pager, next"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="page"
        :page-sizes="[10, 15, 20, 50, 100, 200]"
        :total="total"
        style="float:right;"
      ></el-pagination>
    </el-col>

    <!--查看界面-->
    <el-dialog
      title="查看"
      :visible.sync="lookUpFormVisible"
      v-model="lookUpFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="lookUpForm" label-width="80px" ref="lookUpForm">
        <el-row>
          <el-form-item label="线路名称" prop="LineName" label-width="110px">
            <el-input v-model="lookUpForm.LineName" :disabled="true" />
          </el-form-item>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="发车模版" prop="DepartureTemplate" label-width="110px">
              <el-input v-model="lookUpForm.DepartureTemplate" :disabled="true" />
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="线路模式" prop="LineMode" label-width="110px">
              <el-input v-model="lookUpForm.LineMode" :disabled="true" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="起始站点" prop="StartSite" label-width="110px">
              <el-input v-model="lookUpForm.StartSite" :disabled="true" />
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="结束站点" prop="EndSite" label-width="110px">
              <el-input v-model="lookUpForm.EndSite" :disabled="true" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="班别名称" prop="ClassName" label-width="110px">
              <el-input v-model="lookUpForm.ClassName" :disabled="true" />
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="班次名称" prop="ShiftName" label-width="110px">
              <el-input v-model="lookUpForm.ShiftName" :disabled="true" />
            </el-form-item>
          </el-col>
        </el-row>  
         <el-row>
          <el-col :span="10">
            <el-form-item label="挂班司机" prop="DriverName" label-width="110px">
              <el-input v-model="lookUpForm.DriverName" :disabled="true" />
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="挂班车辆" prop="VehicleName" label-width="110px">
              <el-input v-model="lookUpForm.VehicleName" :disabled="true" />
            </el-form-item>
          </el-col>
        </el-row>  
         <el-row>
          <el-col :span="10">
            <el-form-item label="顶班司机" prop="ReplaceDriverName" label-width="110px">
              <el-input v-model="lookUpForm.ReplaceDriverName" :disabled="true" />
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="顶班车辆" prop="ReplaceVehicleName" label-width="110px">
              <el-input v-model="lookUpForm.ReplaceVehicleName" :disabled="true" />
            </el-form-item>
          </el-col>
        </el-row>  
         <el-row>
          <el-col :span="10">
            <el-form-item label="首次顶班时间" prop="FirstReplaceDateString" label-width="110px">
              <el-input v-model="lookUpForm.FirstReplaceDateString" :disabled="true" />
            </el-form-item>
          </el-col>          
        </el-row>         
        <el-row>
           <el-form-item label="备注" prop="Remarks" label-width="110px">
              <el-input type="textarea" :rows="3" v-model="lookUpForm.Remarks" :disabled="true" />
            </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="发班详情" label-width="110px">
            <el-table
              :data="departureTimeList"
              highlight-current-row
              style="width: 100%;"
              border
            >
              <el-table-column type="index" label="序号" width="60"></el-table-column>
              <el-table-column prop="RunningDirection" label="运行方向" width="150" ></el-table-column>
              <el-table-column prop="StartSite" label="起始站点" width="150" ></el-table-column>
              <el-table-column prop="Times" label="趟次" width="80" ></el-table-column>
              <el-table-column prop="DepartureTimeStr" label="发车时间" width="150" ></el-table-column>
            </el-table>
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="lookUpFormVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <!--编辑挂班信息-->
    <el-dialog
      title="编辑挂班信息"
      :visible.sync="editReplaceFormVisible"
      v-model="editReplaceFormVisible"
      :close-on-click-modal="false"
      :before-close="handleClose"
      width="60%"
    >
      <el-form :model="editReplaceForm" label-width="80px" ref="editReplace">
        
        <el-row>
          <el-col :span="10">
            <el-form-item label="挂班司机" prop="DriverName" label-width="110px">
              <el-select style="width: 100%;" v-model="editReplaceForm.DriverId" @change="AddDrivechange(3,1)" filterable placeholder="请选择司机">
                <el-option
                  v-for="item in driverList"
                  :key="item.Id"
                  :value="item.Id"
                  :label="item.Name"
                >
                  <span style="float: left">{{ item.Name }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="挂班车辆" prop="VehicleName" label-width="110px">
              <el-select style="width: 100%;" v-model="editReplaceForm.VehicleId" filterable placeholder="请选择车牌号">
                <el-option
                  v-for="item in vehicleList"
                  :key="item.Id"
                  :value="item.Id"
                  :label="item.LicensePlateNumber"
                >
                  <span style="float: left">{{ item.LicensePlateNumber }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="顶班司机" prop="ReplaceDriverName" label-width="110px">
              <el-select style="width: 100%;" v-model="editReplaceForm.ReplaceDriverId" @change="AddDrivechange(3,2)" filterable placeholder="请选择司机">
                <el-option
                  v-for="item in driverList"
                  :key="item.Id"
                  :value="item.Id"
                  :label="item.Name"
                >
                  <span style="float: left">{{ item.Name }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="顶班车辆" prop="ReplaceVehicleName" label-width="110px">
              <el-select style="width: 100%;" v-model="editReplaceForm.ReplaceVehicleId" filterable placeholder="请选择车牌号">
                <el-option
                  v-for="item in vehicleList"
                  :key="item.Id"
                  :value="item.Id"
                  :label="item.LicensePlateNumber"
                >
                  <span style="float: left">{{ item.LicensePlateNumber }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="10">
            <el-form-item label="首次顶班时间" prop="FirstReplaceDate" label-width="110px">
               <el-date-picker v-model="editReplaceForm.FirstReplaceDate" type="date" placeholder="请输入选择时间" value-format="yyyy-MM-dd"
                ></el-date-picker>
            </el-form-item>
          </el-col>          
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editReplaceFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="editReplaceFormSubmit" :loading="editReplaceLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--编辑界面-->
    <el-dialog
      title="编辑"
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :close-on-click-modal="false"
      :before-close="handleClose"
      width="60%"
    >
      <el-form :model="editForm" label-width="80px" :rules="editFormRules" ref="editForm">
        <el-row>
          <el-form-item label="公交线路" prop="BusLinesId" label-width="110px">
            <el-select style="width: 100%;" @change="((val)=>{selectBusLinesIdChanged(val, 'Edit')})" v-model="editForm.BusLinesId" placeholder="请选择公交线路">
              <el-option
                v-for="item in busLinesList"
                :key="item.Id"
                :value="item.Id"
                :label="item.LineChineseName"
              >
                <span style="float: left">{{ item.LineChineseName }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="发车模版" prop="SchedulingTemplateId" label-width="110px">
              <el-select style="width: 100%;" v-model="editForm.SchedulingTemplateId" clearable placeholder="请选择发车模版">
                <el-option
                  v-for="item in schedulingTemplateList"
                  :key="item.Id"
                  :value="item.Id"
                  :label="item.DepartureTemplate"
                >
                  <span style="float: left">{{ item.DepartureTemplate }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="线路模式" prop="LineMode" label-width="110px">
              <el-select style="width: 100%;" disabled v-model="editForm.LineMode" placeholder="请选择线路模式">
                <el-option
                  v-for="item in lineModeList"
                  :key="item.Id"
                  :value="item.DictName"
                  :label="item.DictName"
                >
                  <span style="float: left">{{ item.DictName }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="起始站点" prop="StartSite" label-width="110px">
              <el-select style="width: 100%;"  v-model="editForm.StartSite" placeholder="请选择起始站点">
                <el-option
                  v-for="item in siteList"
                  :key="item.Id"
                  :value="item.SiteChineseName"
                  :label="item.SiteChineseName"
                >
                  <span style="float: left">{{ item.SiteChineseName }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="结束站点" prop="EndSite" label-width="110px">
              <el-select style="width: 100%;"  v-model="editForm.EndSite" placeholder="请选择结束站点">
                <el-option
                  v-for="item in siteList"
                  :key="item.Id"
                  :value="item.SiteChineseName"
                  :label="item.SiteChineseName"
                >
                  <span style="float: left">{{ item.SiteChineseName }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="班别名称" prop="ClassName" label-width="110px">
              <el-select style="width: 100%;" @change="((val)=>{selectClassNameChanged(val, 'Edit')})" v-model="editForm.ClassName" placeholder="请选择班别名称">
                <el-option
                  v-for="item in classNameList"
                  :key="item.Id"
                  :value="item"
                  :label="item.DictName"
                >
                  <span style="float: left">{{ item.DictName }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="班次名称" prop="ShiftName" label-width="110px">
              <el-select style="width: 100%;" @change="forceUpdate" v-model="editForm.ShiftName" placeholder="请选择班次名称">
                <el-option
                  v-for="item in shiftNameList"
                  :key="item.Id"
                  :value="item.DictName"
                  :label="item.DictName"
                >
                  <span style="float: left">{{ item.DictName }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row>
          <el-col :span="10">
            <el-form-item label="挂班司机" prop="DriverName" label-width="110px">
              <el-select style="width: 100%;" v-model="editForm.DriverId" @change="AddDrivechange(2,1)" filterable placeholder="请选择司机">
                <el-option
                  v-for="item in driverList"
                  :key="item.Id"
                  :value="item.Id"
                  :label="item.Name"
                >
                  <span style="float: left">{{ item.Name }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="挂班车辆" prop="VehicleName" label-width="110px">
              <el-select style="width: 100%;" v-model="editForm.VehicleId" filterable placeholder="请选择车牌号">
                <el-option
                  v-for="item in vehicleList"
                  :key="item.Id"
                  :value="item.Id"
                  :label="item.LicensePlateNumber"
                >
                  <span style="float: left">{{ item.LicensePlateNumber }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="顶班司机" prop="ReplaceDriverName" label-width="110px">
              <el-select style="width: 100%;" v-model="editForm.ReplaceDriverId" @change="AddDrivechange(2,2)" filterable placeholder="请选择司机">
                <el-option
                  v-for="item in driverList"
                  :key="item.Id"
                  :value="item.Id"
                  :label="item.Name"
                >
                  <span style="float: left">{{ item.Name }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="顶班车辆" prop="ReplaceVehicleName" label-width="110px">
              <el-select style="width: 100%;" v-model="editForm.ReplaceVehicleId" filterable placeholder="请选择车牌号">
                <el-option
                  v-for="item in vehicleList"
                  :key="item.Id"
                  :value="item.Id"
                  :label="item.LicensePlateNumber"
                >
                  <span style="float: left">{{ item.LicensePlateNumber }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="10">
            <el-form-item label="首次顶班时间" prop="FirstReplaceDate" label-width="110px">
               <el-date-picker v-model="editForm.FirstReplaceDate" type="date" placeholder="请输入选择时间" value-format="yyyy-MM-dd"
                ></el-date-picker>
            </el-form-item>
          </el-col>          
        </el-row> -->
        
        <el-row>
          <el-form-item label="备注" prop="Remarks" label-width="110px">
            <el-input type="textarea" :rows="3" v-model="editForm.Remarks" />
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="发班详情" label-width="110px">
            <el-button type="primary" icon="el-icon-plus" size="mini" @click="addDepartureTimeLine('Edit')">添加</el-button>
            <el-table
              :data="departureTimeList"
              highlight-current-row
              style="width: 100%;"
              border
            >
              <el-table-column type="index" label="序号" width="60"></el-table-column>
              <el-table-column prop="RunningDirection" label="运行方向" width="150" >
                <template slot-scope="scope">
                  <el-select
                    v-model="scope.row.RunningDirection"
                  >
                    <el-option
                      v-for="dict in runningDirectionList"
                      :key="dict.Id"
                      :label="dict.DictName"
                      :value="dict.DictName"
                      :disabled="dict.Disabled"
                    />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="StartSite" label="起始站点" width="150" >
                <template slot-scope="scope">
                  <el-select
                    v-model="scope.row.StartSite"
                  >
                    <el-option
                      v-for="item in siteList"
                      :key="item.Id"
                      :value="item.SiteChineseName"
                      :label="item.SiteChineseName"
                    />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="Times" label="趟次" width="80" ></el-table-column>
              <el-table-column prop="DepartureTimeStr" label="发车时间" width="150" >
                <template slot-scope="scope">
                  <el-time-picker v-model="scope.row.DepartureTimeStr" @change="departureTimeStrChange(scope.row,'Edit')" value-format="HH:mm" format="HH:mm" style="width:120px;"></el-time-picker>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button
                    type="danger"
                    v-if="departureTimeList.length > 0"
                    @click="handleDepartureTimeDelete(scope.$index, scope.row)"
                    class="del-btn"
                  >删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editCancel">取消</el-button>
        <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--新增界面-->
    <el-dialog
      title="新增"
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
      width="60%"
    >
      <el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm">
        <el-row>
          <el-form-item label="公交线路" prop="BusLinesId" label-width="110px">
            <el-select style="width: 100%;" @change="((val)=>{selectBusLinesIdChanged(val, 'Add')})" v-model="addForm.BusLinesId" placeholder="请选择公交线路">
              <el-option
                v-for="item in busLinesList"
                :key="item.Id"
                :value="item.Id"
                :label="item.LineChineseName"
              >
                <span style="float: left">{{ item.LineChineseName }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="发车模版" prop="SchedulingTemplateId" label-width="110px">
              <el-select style="width: 100%;" v-model="addForm.SchedulingTemplateId" clearable placeholder="请选择发车模版">
                <el-option
                  v-for="item in schedulingTemplateList"
                  :key="item.Id"
                  :value="item.Id"
                  :label="item.DepartureTemplate"
                >
                  <span style="float: left">{{ item.DepartureTemplate }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="线路模式" prop="LineMode" label-width="110px">
              <el-select style="width: 100%;" disabled v-model="addForm.LineMode" placeholder="请选择线路模式">
                <el-option
                  v-for="item in lineModeList"
                  :key="item.Id"
                  :value="item.DictName"
                  :label="item.DictName"
                >
                  <span style="float: left">{{ item.DictName }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>  

        <el-row>
          <el-col :span="10">
            <el-form-item label="起始站点" prop="StartSite" label-width="110px">
              <el-select style="width: 100%;"  @change="forceUpdate" v-model="addForm.StartSite" placeholder="请选择起始站点">
                <el-option
                  v-for="item in siteList"
                  :key="item.Id"
                  :value="item.SiteChineseName"
                  :label="item.SiteChineseName"
                >
                  <span style="float: left">{{ item.SiteChineseName }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="结束站点" prop="EndSite" label-width="110px">
              <el-select style="width: 100%;"  @change="forceUpdate" v-model="addForm.EndSite" placeholder="请选择结束站点">
                <el-option
                  v-for="item in siteList"
                  :key="item.Id"
                  :value="item.SiteChineseName"
                  :label="item.SiteChineseName"
                >
                  <span style="float: left">{{ item.SiteChineseName }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="班别名称" prop="ClassName" label-width="110px">
              <el-select style="width: 100%;" @change="((val)=>{selectClassNameChanged(val, 'Add')})" v-model="addForm.ClassName" placeholder="请选择班别名称">
                <el-option
                  v-for="item in classNameList"
                  :key="item.Id"
                  :value="item"
                  :label="item.DictName"
                >
                  <span style="float: left">{{ item.DictName }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="班次名称" prop="ShiftName" label-width="110px">
              <el-select style="width: 100%;" @change="forceUpdate" v-model="addForm.ShiftName" placeholder="请选择班次名称">
                <el-option
                  v-for="item in shiftNameList"
                  :key="item.Id"
                  :value="item.DictName"
                  :label="item.DictName"
                >
                  <span style="float: left">{{ item.DictName }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="挂班司机" prop="DriverName" label-width="110px">
              <el-select style="width: 100%;" v-model="addForm.DriverId" @change="AddDrivechange(1,1)" filterable placeholder="请选择司机">
                <el-option
                  v-for="item in driverList"
                  :key="item.Id"
                  :value="item.Id"
                  :label="item.Name"
                >
                  <span style="float: left">{{ item.Name }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="挂班车辆" prop="VehicleName" label-width="110px">
              <el-select style="width: 100%;" v-model="addForm.VehicleId" filterable placeholder="请选择车牌号">
                <el-option
                  v-for="item in vehicleList"
                  :key="item.Id"
                  :value="item.Id"
                  :label="item.LicensePlateNumber"
                >
                  <span style="float: left">{{ item.LicensePlateNumber }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="顶班司机" prop="ReplaceDriverName" label-width="110px">
              <el-select style="width: 100%;" v-model="addForm.ReplaceDriverId" @change="AddDrivechange(1,2)" filterable placeholder="请选择司机">
                <el-option
                  v-for="item in driverList"
                  :key="item.Id"
                  :value="item.Id"
                  :label="item.Name"
                >
                  <span style="float: left">{{ item.Name }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="顶班车辆" prop="ReplaceVehicleName" label-width="110px">
              <el-select style="width: 100%;" v-model="addForm.ReplaceVehicleId" filterable placeholder="请选择车牌号">
                <el-option
                  v-for="item in vehicleList"
                  :key="item.Id"
                  :value="item.Id"
                  :label="item.LicensePlateNumber"
                >
                  <span style="float: left">{{ item.LicensePlateNumber }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="10">
            <el-form-item label="首次顶班时间" prop="FirstReplaceDate" label-width="110px">
               <el-date-picker v-model="addForm.FirstReplaceDate" type="date" placeholder="请输入选择时间" value-format="yyyy-MM-dd"
                ></el-date-picker>
            </el-form-item>
          </el-col>          
        </el-row>
        <el-row>
           <el-form-item label="备注" prop="Remarks" label-width="110px">
              <el-input type="textarea" :rows="3" v-model="addForm.Remarks" />
            </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="设置模式" prop="SettingMode" label-width="110px">
            <el-radio-group @change="settingModeChange" v-model="settingMode">
              <el-radio label="手动"></el-radio>
              <el-radio label="自动"></el-radio>
            </el-radio-group>
          </el-form-item>
        </el-row>
        <div v-if="settingMode === '手动'">
          <el-row>
            <el-form-item label-width="110px">
              <el-button type="primary" icon="el-icon-plus" size="mini" @click="addDepartureTimeLine('Add')">添加</el-button>
              <el-table
                :data="departureTimeList"
                highlight-current-row
                style="width: 100%;"
                border
              >
                <el-table-column type="index" label="序号" width="60"></el-table-column>
                <el-table-column prop="RunningDirection" label="运行方向" width="150" >
                  <template slot-scope="scope">
                    <el-select
                      v-model="scope.row.RunningDirection"
                    >
                      <el-option
                        v-for="dict in runningDirectionList"
                        :key="dict.Id"
                        :label="dict.DictName"
                        :value="dict.DictName"
                        :disabled="dict.Disabled"
                      />
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column prop="StartSite" label="起始站点" width="150" >
                  <template slot-scope="scope">
                    <el-select
                      v-model="scope.row.StartSite"
                    >
                      <el-option
                        v-for="item in siteList"
                        :key="item.Id"
                        :value="item.SiteChineseName"
                        :label="item.SiteChineseName"
                      />
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column prop="Times" label="趟次" width="80" ></el-table-column>
                <el-table-column prop="DepartureTimeStr" label="发车时间" width="150" >
                  <template slot-scope="scope">
                    <el-time-picker v-model="scope.row.DepartureTimeStr" @change="departureTimeStrChange(scope.row,'Add')" value-format="HH:mm" format="HH:mm" style="width:120px;"></el-time-picker>
                  </template>
                </el-table-column>
                <el-table-column label="操作" align="center">
                  <template slot-scope="scope">
                    <el-button
                      type="danger"
                      v-if="departureTimeList.length > 0"
                      @click="handleDepartureTimeDelete(scope.$index, scope.row)"
                      class="del-btn"
                    >删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
          </el-row>
        </div>
        <div v-if="settingMode === '自动' && addForm.BusLinesId > 0">
          <el-row>
            <el-col :span="10">
              <el-form-item label="首班发班时间" prop="firstShiftTime" label-width="110px">
                <el-time-picker v-model="firstShiftTime" value-format="HH:mm" format="HH:mm" style="width:180px;"></el-time-picker>
              </el-form-item>
            </el-col>
            <el-col :span="10" style="float:right;">
              <el-form-item label="发班次数" prop="shiftsTimes" label-width="110px">
                <el-input v-number-only v-model="shiftsTimes" style="width:180px;"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="addForm.LineMode === '环行'">
            <el-col :span="10">
              <el-form-item label="运行时长" prop="operationDuration" label-width="110px">
                <el-input v-number-only v-model="operationDuration" style="width:180px;"></el-input> 分钟
              </el-form-item>
            </el-col>
            <el-col :span="10" style="float:right;">
              <el-form-item label="休息时长" prop="restDuration" label-width="110px">
                <el-input v-number-only v-model="restDuration" style="width:180px;"></el-input> 分钟
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="addForm.LineMode === '上下行'">
            <el-col :span="10">
              <el-form-item label="上行运行时长" prop="upOperationDuration" label-width="110px">
                <el-input v-number-only v-model="upOperationDuration" style="width:180px;"></el-input> 分钟
              </el-form-item>
            </el-col>
            <el-col :span="10" style="float:right;">
              <el-form-item label="上行休息时长" prop="upRestDuration" label-width="110px">
                <el-input v-number-only v-model="upRestDuration" style="width:180px;"></el-input> 分钟
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="addForm.LineMode === '上下行'">
            <el-col :span="10">
              <el-form-item label="下行运行时长" prop="downOperationDuration" label-width="110px">
                <el-input v-number-only v-model="downOperationDuration" style="width:180px;"></el-input> 分钟
              </el-form-item>
            </el-col>
            <el-col :span="10" style="float:right;">
              <el-form-item label="下行休息时长" prop="downRestDuration" label-width="110px">
                <el-input v-number-only v-model="downRestDuration" style="width:180px;"></el-input> 分钟
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="3">
              <el-button type="primary" @click="generateScheduling()">生成排班</el-button>
            </el-col>
            <el-col :span="20" v-if="scheduling === true">
              <el-button type="primary" icon="el-icon-plus" size="mini" @click="addDepartureTimeLine('Add')">添加</el-button>
              <el-table
                :data="departureTimeList"
                highlight-current-row
                style="width: 100%;"
                border
              >
                <el-table-column type="index" label="序号" width="60"></el-table-column>
                <el-table-column prop="RunningDirection" label="运行方向" width="150" >
                  <template slot-scope="scope">
                    <el-select
                      v-model="scope.row.RunningDirection"
                    >
                      <el-option
                        v-for="dict in runningDirectionList"
                        :key="dict.Id"
                        :label="dict.DictName"
                        :value="dict.DictName"
                        :disabled="dict.Disabled"
                      />
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column prop="StartSite" label="起始站点" width="150" >
                  <template slot-scope="scope">
                    <el-select
                      v-model="scope.row.StartSite"
                    >
                      <el-option
                        v-for="item in siteList"
                        :key="item.Id"
                        :value="item.SiteChineseName"
                        :label="item.SiteChineseName"
                      />
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column prop="Times" label="趟次" width="80" ></el-table-column>
                <el-table-column prop="DepartureTimeStr" label="发车时间" width="150" >
                  <template slot-scope="scope">
                    <el-time-picker v-model="scope.row.DepartureTimeStr" @change="departureTimeStrChange(scope.row,'Add')" value-format="HH:mm" format="HH:mm" style="width:120px;"></el-time-picker>
                  </template>
                </el-table-column>
                <el-table-column label="操作" align="center">
                  <template slot-scope="scope">
                    <el-button
                      type="danger"
                      v-if="departureTimeList.length > 0"
                      @click="handleDepartureTimeDelete(scope.$index, scope.row)"
                      class="del-btn"
                    >删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--修改发车时间-->
    <el-dialog
      title="修改发车时间"
      :visible.sync="editDepartureTimeStrFormVisible"
      v-model="editDepartureTimeStrFormVisible"
      :close-on-click-modal="false"
      width="25%"
    >
      <el-form :model="editDepartureTimeStrForm" label-width="80px" :rules="editDepartureTimeStrFormRules" ref="editDepartureTimeStrForm">
        <el-row>
           <el-form-item label="发车时间" prop="DepartureTimeStr" label-width="110px">
              <el-time-picker v-model="editDepartureTimeStrForm.DepartureTimeStr" value-format="HH:mm" format="HH:mm"></el-time-picker>
            </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editDepartureTimeStrFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="editDepartureTimeStrSubmit" :loading="editDepartureTimeStrLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--操作日记-->
    <el-dialog
      title="操作日记"
      :visible.sync="operateDataLogFormVisible"
      v-model="operateDataLogFormVisible"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      width="60%"
    >
      <OperateDataLog v-if="operateDataLogFormVisible" :entityName="entityName" :entityKey="entityKey"></OperateDataLog>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="operateDataLogFormVisible = false">关闭</el-button>
      </div>
    </el-dialog>              

    <!--子表操作日记-->
    <el-dialog
      title="子表操作日记"
      :visible.sync="subOperateDataLogFormVisible"
      v-model="subOperateDataLogFormVisible"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      width="60%"
    >
      <SubOperateDataLog v-if="subOperateDataLogFormVisible" :parentEntityName="entityName" :parentEntityKey="entityKey"></SubOperateDataLog>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="subOperateDataLogFormVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import util from "../../../util/date";
import { getShiftListPage, removeShift, editShift, editReplaceShift,addShift,getBusLinesListPage, getBusLineDirectionByBusLinesId,getDictionaryListPageByDictNameAndDictCode,getDictionaryListPageByPid,editDepartureTime,getSchedulingTemplateListPage,getDriverListPage,getVehiclesListPage,getByDriverIdVehiclesData } from "../../api/api";
import { getButtonList,getOperationButtonList } from "../../promissionRouter";
import ShiftToolbar from "../../components/QueryToolbar/ShiftToolbar";
import OperateDataLog from "../../components/OperateDataLog";
import SubOperateDataLog from "../../components/SubOperateDataLog";

export default {
  components: { ShiftToolbar,OperateDataLog,SubOperateDataLog },
  data() {
    return {
      filters: {
        busLinesId: "",
        schedulingTemplateId:"",
        startSite: "",
        className: "",
        shiftName: ""
      },
      entityName: 'Shift', //操作日记中的表名称
      entityKey: '',  //操作日记中的表的Id
      settingMode: "手动",
      scheduling: false,
      firstShiftTime:"06:20",
      shiftsTimes:1,
      operationDuration:0,
      restDuration:0,
      upOperationDuration:0,
      upRestDuration:0,
      downOperationDuration:0,
      downRestDuration:0,
      buttonList: [],
      operationButtonList: [],
      shiftList: [], //班次列表
      busLinesList: [], //线路列表
      lineModeList: [], //线路模式列表
      runningDirectionList: [], //运行方向列表
      siteList: [], //站点列表
      classNameList: [], //班别列表
      shiftNameList: [], //班次列表
      departureTimeList: [], //发车时间列表
      schedulingTemplateList: [], //排班模版列表
      driverList: [], //驾驶员原始列表
      vehicleList: [], //车辆列表
      statusList: [
        { name: "激活", value: true },
        { name: "禁用", value: false }
      ],
      total: 0,
      page: 1,
      pageSize: 10,
      listLoading: false,
      sels: [], //列表选中列
      currentRow: null,
      addDialogFormVisible: false,
      operateDataLogFormVisible: false, //查看操作日记界面是否显示
      subOperateDataLogFormVisible: false, //查看子表操作日记界面是否显示
      lookUpFormVisible: false, //查看界面是否显示
      //查看界面数据
      lookUpForm: {
        Id: 0,
        CreateBy: "",
        BusLinesId: 0,
        SchedulingTemplateId: 0,
        LineName: "",
        DepartureTemplate: "",
        LineMode: "",
        StartSite: "",
        EndSite: "",
        ClassName: "",
        ShiftName: "",
        DriverName: "",
        vehicleName: "",
        ReplaceDriverName: "",
        ReplaceVehicleName: "",
        FirstReplaceDate:"",
        Remarks: "",
        DepartureTime: []
      },
      editReplaceFormVisible: false, //编辑挂班界面是否显示
      editReplaceLoading: false,
      //编辑挂班界面数据
      editReplaceForm: {
        Id: 0,
        CreateBy: "",
        BusLinesId: 0,
        OldBusLinesId: 0,
        Enabled: true,
        LineMode: "",
        StartSite: "",
        EndSite: "",
        ClassName: "",
        ShiftName: "",
        DriverId: 0,
        vehicleId: 0,
        ReplaceDriverId: 0,
        ReplaceVehicleId: 0,
        FirstReplaceDate:"",
        Remarks: "",
        DepartureTime: []
      },
      //编辑界面数据
      editReplace: {
        Id: 0,
        CreateBy: "",
        BusLinesId: 0,
        OldBusLinesId: 0,
        Enabled: true,
        LineMode: "",
        StartSite: "",
        EndSite: "",
        ClassName: "",
        ShiftName: "",
        DriverId: 0,
        vehicleId: 0,
        ReplaceDriverId: 0,
        ReplaceVehicleId: 0,
        FirstReplaceDate:"",
        Remarks: "",
        DepartureTime: []
      },
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: {
        BusLinesId: [{ required: true, message: "请选择归属线路", trigger: "blur" }],
        LineMode: [{ required: true, message: "请选择线路模式", trigger: "blur" }],
        StartSite: [{ required: true, message: "请选择起始站点", trigger: "blur" }],
        EndSite: [{ required: true, message: "请选择结束站点", trigger: "blur" }],
        ClassName: [{ required: true, message: "请选择班别名称", trigger: "blur" }],
        ShiftName: [{ required: true, message: "请选择班次名称", trigger: "blur" }]
      },
      //编辑界面数据
      editForm: {
        Id: 0,
        CreateBy: "",
        BusLinesId: 0,
        OldBusLinesId: 0,
        Enabled: true,
        LineMode: "",
        StartSite: "",
        EndSite: "",
        ClassName: "",
        ShiftName: "",
        DriverId: 0,
        vehicleId: 0,
        ReplaceDriverId: 0,
        ReplaceVehicleId: 0,
        FirstReplaceDate:"",
        Remarks: "",
        DepartureTime: []
      },
      editDepartureTimeStrFormVisible: false, //修改发车时间界面是否显示
      editDepartureTimeStrLoading: false,
      editDepartureTimeStrFormRules: {
        DepartureTimeStr: [{ required: true, message: "发车时间不能为空", trigger: "blur" }]
      },
      //编辑界面数据
      editDepartureTimeStrForm: {
        Id: 0,
        CreateBy: "",
        BusLinesId: 0,
        SchedulingTemplateId:0,
        Enabled: true,
        ShiftId: 0,
        RunningDirection: "",
        StartSite: "",
        Times: 0,
        DepartureTimeStr: "",
        LineMode: ""
      },

      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        BusLinesId: [{ required: true, message: "请选择归属线路", trigger: "blur" }],
        LineMode: [{ required: true, message: "请选择线路模式", trigger: "blur" }],
        StartSite: [{ required: true, message: "请选择起始站点", trigger: "blur" }],
        EndSite: [{ required: true, message: "请选择结束站点", trigger: "blur" }],
        ClassName: [{ required: true, message: "请选择班别名称", trigger: "blur" }],
        ShiftName: [{ required: true, message: "请选择班次名称", trigger: "blur" }]
      },
      //新增界面数据
      addForm: {
        CreateBy: "",
        CreateId: "",
        BusLinesId: 0,
        SchedulingTemplateId:0,
        Enabled: true,
        LineMode: "",
        StartSite: "",
        EndSite: "",
        ClassName: "",
        ShiftName: "",
        DriverId: 0,
        vehicleId: 0,
        ReplaceDriverId: 0,
        ReplaceVehicleId: 0,
        FirstReplaceDate:"",
        Remarks: "",
        DepartureTime: []
      },
      multipleSelection: []
    };
  },
  methods: {
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this.filters = {
        busLinesId: item.busLinesId,
        schedulingTemplateId: item.schedulingTemplateId,
        startSite: item.startSite,
        className: item.className,
        shiftName: item.shiftName
      };
      this[item.Func].apply(this, item);
    },
    operationButtonFunction(item,row){
      this.currentRow = row;
      this[item.Func].apply(this,item);
    },
    handleSizeChange(val) {
      this.page = 1;
      this.pageSize = val;
      this.getShift();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getShift();
    },
    queryShift(){
      this.page = 1;
      this.getShift();
    },
    selectBusLinesIdChanged(value,type) {
      this.siteList=[];
      if(value!==""){
        this.getSiteList(value,type);
        this.getSchedulingTemplateList(value);
      }
      this.runningDirectionInit(value,type);
    },
    getDriverList(){
      let driverPara = {
        companyId: "",
        driverName: "",
        employmentStatus: "",
        page: 1,
        pageSize: 200
      };
      getDriverListPage(driverPara).then(res => {
        this.driverList = res.data.response.data;
      });
    },
    getVehiclesList(){
      let vehiclesPara = {
        companyId: '',
        busLinesId: '',
        licensePlateNumber: '',
        terminalsId: '',
        simId: '',
        page: 1,
        pageSize: 200
      };
      getVehiclesListPage(vehiclesPara).then(res => {
        this.vehicleList = res.data.response.data;
      });
    },
    getSiteList(value,type){
      let para = {
        busLinesId: value
      };
      getBusLineDirectionByBusLinesId(para).then(res => {
        this.siteList = res.data.data;
        let startSite = this.siteList.length>0?this.siteList[0].SiteChineseName:"";
        let endSite = startSite;
        let busLinesList = this.busLinesList.filter(item => item.Id === value);
        let lineMode = busLinesList.length>0?busLinesList[0].LineMode:"";
        this.runningDirectionDisabled(lineMode);
        if(lineMode === "上下行"){
          endSite = this.siteList.length>1?this.siteList[1].SiteChineseName:"";
        }

        if(type==="Add"){
          this.addForm.LineMode=lineMode;
          this.addForm.StartSite=startSite;
          this.addForm.EndSite=endSite;
          this.startSiteInit(this.siteList);
        }else if(type==="Edit"){
          this.editForm.LineMode=lineMode;
          this.editForm.StartSite=startSite;
          this.editForm.EndSite=endSite;
          this.startSiteInit(this.siteList);
        }
      });
    },
    //修改司机change
    AddDrivechange(a,b) {
      let _this = this;
      let para = {
        busLinesId: _this.editForm.BusLinesId,
        driverId: _this.editForm.DriverId,
        vehicleId: '',
        isBind: '',
        page: _this.page,
        pageSize: _this.pageSize
      };    
      if(a == 1)
      {
        if(b==1)
        {
          para.driverId = _this.addForm.DriverId;   
        }
        if(b==2)
        {
          para.driverId = _this.addForm.ReplaceDriverId;   
        }
      }
      if(a == 2)
      {
        if(b==1)
        {
          para.driverId = _this.editForm.DriverId;   
        }
        if(b==2)
        {
          para.driverId = _this.editForm.ReplaceDriverId;
        }
      }
      if(a == 3)
      {
        if(b==1)
        {
          para.driverId = _this.editReplaceForm.DriverId;   
        }
        if(b==2)
        {
          para.driverId = _this.editReplaceForm.ReplaceDriverId;
        }
      }
      getByDriverIdVehiclesData(para).then(res => {
        if(res.data.data !== null)
        {
          if(res.data.data.length > 0)
          {
            if(a == 1)
            {
              if(b==1)
              {
                _this.addForm.VehicleId = res.data.data[0].Id;   
              }
              if(b==2)
              {
                _this.addForm.ReplaceVehicleId = res.data.data[0].Id;   
              }
            }
            if(a == 2)
            {
              if(b==1)
              {
                _this.editForm.VehicleId = res.data.data[0].Id;   
              }
              if(b==2)
              {
                _this.editForm.ReplaceVehicleId = res.data.data[0].Id;   
              }
            }
            if(a == 3)
            {
              if(b==1)
              {
                _this.editReplaceForm.VehicleId = res.data.data[0].Id;   
              }
              if(b==2)
              {
                _this.editReplaceForm.ReplaceVehicleId = res.data.data[0].Id;   
              }
            }
                      
          }
        }
        
           
      });      
    },
    selectClassNameChanged(value,type) {
      this.shiftNameList=[];
      if(type==="Add"){
        this.addForm.ShiftName="";
        this.addForm.ClassName=value.DictName;
      }else if(type==="Edit"){
        this.editForm.ShiftName="";
        this.editForm.ClassName=value.DictName;
      }
      if(value.Id > 0){
        this.getShiftNameList(value.Id);
      }
    },
    runningDirectionDisabled(value){
      if(this.runningDirectionList.length > 0){
        this.runningDirectionList.forEach(item=>{
          if(value === "上下行"){
            if(item.DictName === "环行"){
              item.Disabled = true;
            }else{
              item.Disabled = false;
            }
          }else if(value === "环行"){
            if(item.DictName === "上行" || item.DictName === "下行"){
              item.Disabled = true;
            }else{
              item.Disabled = false;
            }
          }
        })
      }
    },
    runningDirectionInit(value,type){
      if(this.departureTimeList.length > 0){
        let busLinesList = this.busLinesList.filter(item => item.Id === value);
        let lineMode = busLinesList.length>0?busLinesList[0].LineMode:"";
        if(type==="Add"){
          this.departureTimeList.forEach(item=>{
            item.RunningDirection = lineMode === "环行"?"环行":"上行";
          })
        }else if(type==="Edit"){
          this.departureTimeList.forEach(item=>{
            item.RunningDirection = lineMode === "环行"?"环行":"上行";
          })
        }
      }
    },
    startSiteInit(siteList){
      if(this.departureTimeList.length > 0){
        this.departureTimeList.forEach(item=>{
          item.StartSite = siteList.length>0?siteList[0].SiteChineseName:"";
        })
      }
    },
    listClear(){
      this.departureTimeList=[];
      this.siteList=[];
      this.shiftNameList=[];
      this.schedulingTemplateList=[];
    },
    settingModeChange(value){
      this.settingMode = value;
    },
    schedulingInit(){
      this.firstShiftTime = "06:20";
      this.shiftsTimes = 1;
      this.operationDuration = 0;
      this.restDuration = 0;
      this.upOperationDuration = 0;
      this.upRestDuration = 0;
      this.downOperationDuration = 0;
      this.downRestDuration = 0;
    },
    departureTimeStrChange(row,type){
      row.DepartureTimeInt = parseInt(row.DepartureTimeStr.replace(":",""));
      this.departureTimeListSortAsc(type);
    },
    departureTimeListSortAsc(type){
      if(this.departureTimeList.length > 0){
        this.departureTimeList = this.departureTimeList.sort(this.compareAsc("DepartureTimeInt"));
        let index = 0;
        this.departureTimeList.forEach(item=>{
          index++; 
          if(type==="Add"){
            if(this.addForm.LineMode === "上下行"){
              item.Times = this.UpAndDownSerialNumber(index);
            }else if(this.addForm.LineMode === "环行"){
              item.Times =index;
            }
          }else{
            if(this.editForm.LineMode === "上下行"){
              item.Times = this.UpAndDownSerialNumber(index);
            }else if(this.editForm.LineMode === "环行"){
              item.Times =index;
            }
          }
        })
      }
    },
    UpAndDownSerialNumber(index){
      let merchant = parseInt(index/2); //取商
      let remainder = parseInt(index%2)  //取余数
      return parseInt(merchant)+parseInt(remainder);
    },
    compareAsc(property){
      return function(a,b){
        let value1 = a[property];
        let value2 = b[property];
        return value1 - value2;
      }
    },
    forceUpdate(value) {
      this.$forceUpdate();
    },
    getShiftNameList(id){
      let para = {
        Pid: id,
        pageSize: 100
      };
      getDictionaryListPageByPid(para).then(res => {
         this.shiftNameList = res.data.data;
      });
    },
    //获取班次列表
    getShift() {
      let _this = this;
      let para = {
        busLinesId: _this.filters.busLinesId,
        schedulingTemplateId: _this.filters.schedulingTemplateId,
        startSite: _this.filters.startSite,
        className: _this.filters.className,
        shiftName: _this.filters.shiftName,
        page: _this.page,
        pageSize: _this.pageSize,
      };
      _this.listLoading = true;
      getShiftListPage(para).then(res => {
        _this.total = res.data.response.dataCount;
        _this.shiftList = res.data.response.data;
        _this.listLoading = false;
      });
    },
    getSchedulingTemplateList(busLinesId){
      let para = {
        busLinesId: busLinesId
      };
      getSchedulingTemplateListPage(para).then(res => {
         this.schedulingTemplateList = res.data.response.data;
      });
    },
    //删除
    handleDel() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要删除的一行数据！",
          type: "error"
        });

        return;
      }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning"
      })
      .then(() => {
        this.listLoading = true;
        let para = { id: row.Id };
        removeShift(para).then(res => {
          if (util.isEmt.format(res)) {
            this.listLoading = false;
            return;
          }
          this.listLoading = false;
          if (res.data.success) {
            this.$message({
              message: "删除成功",
              type: "success"
            });
          } else {
            this.$message({
              message: res.data.msg,
              type: "error"
            });
          }

          this.getShift();
        });
      })
      .catch(() => {});
    },
    //显示查看界面
    handleLookUp() {
      this.lookUpFormVisible = true;
      this.lookUpForm = Object.assign({}, this.currentRow);
      this.listClear();
      if(this.lookUpForm.ClassName !== "" && this.lookUpForm.ClassName !== null && this.classNameList.length > 0){
        let tempClassNameList = this.classNameList.filter(item => item.DictName == this.editForm.ClassName);
        if(tempClassNameList.length > 0){
          this.getShiftNameList(tempClassNameList[0].Id);
        }
      }
      this.departureTimeList = this.lookUpForm.DepartureTime;
    },
    //显示编辑挂班界面
    handleEditReplace() {
      this.editReplaceFormVisible = true;
      this.editReplaceLoading = false;
      this.editReplaceForm = Object.assign({}, this.currentRow);
      this.editReplaceForm.OldBusLinesId = this.editReplaceForm.BusLinesId;
      this.listClear();
      if(this.editReplaceForm.SchedulingTemplateId === 0){
        this.editReplaceForm.SchedulingTemplateId = "";
      }
      if(this.editReplaceForm.BusLinesId > 0){
        this.getSiteList(this.editReplaceForm.BusLinesId,"");
        this.getSchedulingTemplateList(this.editReplaceForm.BusLinesId);
      }
      if(this.editReplaceForm.ClassName !== "" && this.editReplaceForm.ClassName !== null && this.classNameList.length > 0){
        let tempClassNameList = this.classNameList.filter(item => item.DictName == this.editReplaceForm.ClassName);
        if(tempClassNameList.length > 0){
          this.getShiftNameList(tempClassNameList[0].Id);
        }
      }
      this.departureTimeList = this.editReplaceForm.DepartureTime;
      this.runningDirectionDisabled(this.editReplaceForm.LineMode);
    },
    //显示编辑界面
    handleEdit() {
      this.editFormVisible = true;
      this.editForm = Object.assign({}, this.currentRow);
      this.editForm.OldBusLinesId = this.editForm.BusLinesId;
      this.listClear();
      if(this.editForm.SchedulingTemplateId === 0){
        this.editForm.SchedulingTemplateId = "";
      }
      if(this.editForm.BusLinesId > 0){
        this.getSiteList(this.editForm.BusLinesId,"");
        this.getSchedulingTemplateList(this.editForm.BusLinesId);
      }
      if(this.editForm.ClassName !== "" && this.editForm.ClassName !== null && this.classNameList.length > 0){
        let tempClassNameList = this.classNameList.filter(item => item.DictName == this.editForm.ClassName);
        if(tempClassNameList.length > 0){
          this.getShiftNameList(tempClassNameList[0].Id);
        }
      }
      this.departureTimeList = this.editForm.DepartureTime;
      this.runningDirectionDisabled(this.editForm.LineMode);
    },
    //显示修改发车时间界面
    handleDepartureTimeEdit(row,lineMode) {
      this.editDepartureTimeStrFormVisible = true;
      this.editDepartureTimeStrForm = Object.assign({}, row);
      this.editDepartureTimeStrForm.LineMode = lineMode;
    },
    //显示新增界面
    handleAdd() {
      this.settingMode = "手动";
      this.scheduling = false;
      this.schedulingInit();
      this.addFormVisible = true;
      this.addForm = {
        CreateBy: "",
        CompanyName: "",
        Enabled: "true"
      };
      this.listClear();
    },
    handleClose(done) {
      this.getShift();
      done();
    },
    editCancel:function(){
      this.editFormVisible = false;
      this.getShift();
    },
    //查看操作日记
    lookUpOperateDataLog() {
      this.operateDataLogFormVisible = true;
      this.entityKey = this.currentRow.Id;
    },
    //查看子表操作日记
    lookUpSubOperateDataLog() {
      this.subOperateDataLogFormVisible = true;
      this.entityKey = this.currentRow.Id;
    },
    //编辑
    editSubmit: function() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editLoading = true;
            let para = Object.assign({}, this.editForm);
            para.DepartureTime = this.departureTimeList;

            if(para.SchedulingTemplateId === ""){
              para.SchedulingTemplateId = 0;
              para.DepartureTemplate = "";
            }

            editShift(para).then(res => {
              if (util.isEmt.format(res)) {
                this.editLoading = false;
                return;
              }

              if (res.data.success) {
                this.editLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success"
                });
                this.$refs["editForm"].resetFields();
                this.editFormVisible = false;
                this.getShift();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error"
                });
              }
            });
          });
        }
      });
    },
    //编辑挂班
    editReplaceFormSubmit: function() {
      this.$refs.editReplace.validate(valid => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editReplaceLoading = true;
            let para = Object.assign({}, this.editReplaceForm);
            editReplaceShift(para).then(res => {
              if (util.isEmt.format(res)) {
                this.editReplaceLoading = false;
                return;
              }

              if (res.data.success) {
                this.editLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success"
                });
                this.$refs["editReplace"].resetFields();
                this.editReplaceFormVisible = false;
                this.getShift();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error"
                });
              }
            });
          });
        }
      });
    },
    //新增
    addSubmit: function() {
      let _this = this;
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            let para = Object.assign({}, this.addForm);
            para.DepartureTime = this.departureTimeList;
            if(para.SchedulingTemplateId === ""){
              para.SchedulingTemplateId = 0;
              para.DepartureTemplate = "";
            }

            var user = JSON.parse(window.localStorage.user);

            if (user && user.uID > 0) {
              para.CreateId = user.uID;
              para.CreateBy = user.uRealName;
            } else {
              this.$message({
                message: "用户信息为空，先登录",
                type: "error"
              });
              _this.$router.replace(
                _this.$route.query.redirect ? _this.$route.query.redirect : "/"
              );
            }

            addShift(para).then(res => {
              if (util.isEmt.format(res)) {
                this.addLoading = false;
                return;
              }
              if (res.data.success) {
                this.addLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success"
                });
                this.$refs["addForm"].resetFields();
                this.addFormVisible = false;
                this.getShift();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error"
                });
              }
            });
          });
        }
      });
    },
    //修改发车时间
    editDepartureTimeStrSubmit: function(){
      this.$refs.editDepartureTimeStrForm.validate(valid => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editDepartureTimeStrLoading = true;
            let para = Object.assign({}, this.editDepartureTimeStrForm);

            editDepartureTime(para).then(res => {
              if (util.isEmt.format(res)) {
                this.editDepartureTimeStrLoading = false;
                return;
              }

              if (res.data.success) {
                this.editDepartureTimeStrLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success"
                });
                this.$refs["editDepartureTimeStrForm"].resetFields();
                this.editDepartureTimeStrFormVisible = false;
                this.getShift();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error"
                });
              }
            });
          });
        }
      });
    },
    selsChange: function(sels) {
      this.sels = sels;
    },
    //批量删除
    batchRemove: function() {
      this.$message({
        message: "该功能未开放",
        type: "warning"
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    generateScheduling(){
      this.scheduling = true;
      this.departureTimeList = [];
      if(this.isTimePart(this.firstShiftTime) && !isNaN(this.shiftsTimes) && parseInt(this.shiftsTimes)>0){
        if(this.addForm.LineMode === "环行" && !isNaN(this.operationDuration) && parseInt(this.operationDuration)>0 && !isNaN(this.restDuration)){
          let circularDepartureTimeStr = this.firstShiftTime;
          for(let i=0; i<this.shiftsTimes;i++){
            if(i > 0){
              circularDepartureTimeStr = this.timeAddMinutes(circularDepartureTimeStr,parseInt(this.operationDuration)+parseInt(this.restDuration));
            }
            let obj = {};
            obj.RunningDirection = "环行";
            obj.StartSite = this.addForm.StartSite;
            obj.Times =i+1;
            obj.DepartureTimeStr = circularDepartureTimeStr;
            obj.DepartureTimeInt = parseInt(circularDepartureTimeStr.replace(":",""));
            this.departureTimeList.push(obj);
          }
        }else if(this.addForm.LineMode === "上下行" && !isNaN(this.upOperationDuration) && parseInt(this.upOperationDuration)>0 && !isNaN(this.upRestDuration) && !isNaN(this.downOperationDuration) && parseInt(this.downOperationDuration)>0 && !isNaN(this.downRestDuration)){
          let upDepartureTimeStr = this.firstShiftTime;
          let downDepartureTimeStr = this.firstShiftTime;
          for(let j=0; j<this.shiftsTimes;j++){
            if(j > 0){
              upDepartureTimeStr = this.timeAddMinutes(downDepartureTimeStr,parseInt(this.downOperationDuration)+parseInt(this.downRestDuration));
            }
            downDepartureTimeStr = this.timeAddMinutes(upDepartureTimeStr,parseInt(this.upOperationDuration)+parseInt(this.upRestDuration));
            
            let upObj = {};
            upObj.RunningDirection = "上行";
            upObj.StartSite = this.addForm.StartSite;
            upObj.Times =j+1;
            upObj.DepartureTimeStr = upDepartureTimeStr;
            upObj.DepartureTimeInt = parseInt(upDepartureTimeStr.replace(":",""));
            this.departureTimeList.push(upObj);
            
            let downObj = {};
            downObj.RunningDirection = "下行";
            downObj.StartSite = this.addForm.EndSite;
            downObj.Times =j+1;
            downObj.DepartureTimeStr = downDepartureTimeStr;
            downObj.DepartureTimeInt = parseInt(downDepartureTimeStr.replace(":",""));
            this.departureTimeList.push(downObj);
          }
        }
      }
    },
    isTimePart(timeStr){
      let parts = timeStr.split(':');
      if (parts.length < 1) {
          //日期部分不允许缺少小时、分钟中的任何一项
          return false;
      }
      for (let i = 0; i < parts.length; i++) {
        //如果构成时间的某个部分不是数字，则返回false
        if (isNaN(parts[i])) {
          return false;
        }
      }
      let h = parts[0]; 
      let m = parts[1]; 
      if (parseInt(h) < 0 || parseInt(h) > 23) {
        return false;
      }
      if (parseInt(m) < 0 || parseInt(m) > 59) {
        return false;
      }
      return true;
    },
    timeAddMinutes(time, min){
      let t = time.split(":");     // convert to array [hh, mm]
      let h = Number(t[0]);         // get hours
      let m = Number(t[1]);         // get minutes
      m+= min % 60;                 // increment minutes
      h+= Math.floor(min/60);       // increment hours
      if (m >= 60) { // if resulting minues > 60 then increment hours and balance as minutes
        h++; 
        m-=60;
      }   

      return (h+"").padStart(2,"0") + ":" +(m+"").padStart(2,"0"); //create string padded with zeros for HH and MM
    },
    addDepartureTimeLine(type) {
      let obj = {};
      obj.RunningDirection = "";
      obj.StartSite = "";
      obj.Times =1;
      obj.DepartureTimeStr = "";
      obj.DepartureTimeInt = 0;
      if(type === "Add"){
        if(this.addForm.LineMode === "环行"){
          obj.RunningDirection = "环行";
        }else if(this.addForm.LineMode === "上下行"){
          obj.RunningDirection = "上行";
        }
        obj.StartSite = this.addForm.StartSite;
        this.$refs.addForm.validate(valid => {
          if (valid) {
            this.departureTimeList.push(obj);
          }
        });
      }else if(type === "Edit"){
        if(this.editForm.LineMode === "环行"){
          obj.RunningDirection = "环行";
        }else if(this.editForm.LineMode === "上下行"){
          obj.RunningDirection = "上行";
        }
        obj.StartSite = this.editForm.StartSite;
        this.$refs.editForm.validate(valid => {
          if (valid) {
            this.departureTimeList.push(obj);
          }
        });
      }
    },
    handleDepartureTimeDelete (index) {
      //删除行数
      this.departureTimeList.splice(index, 1);
    }
  },
  mounted() {
    this.getShift();
    this.getDriverList();
    this.getVehiclesList();
    
    let pageSizePara = {
      pageSize: 100
    };
    getBusLinesListPage(pageSizePara).then(res => {
      this.busLinesList = res.data.response.data;
    });

    let para = {
      dictName: '线路模式',
      dictCode: 'LineMode',
      pageSize: 100
    };
    getDictionaryListPageByDictNameAndDictCode(para).then(res => {
      this.lineModeList = res.data.data;
    });

    para = {
      dictName: '班别',
      dictCode: 'Class',
      pageSize: 100
    };
    getDictionaryListPageByDictNameAndDictCode(para).then(res => {
      this.classNameList = res.data.data;
    });
    
    para = {
      dictName: '运行方向',
      dictCode: 'RunningDirection',
      pageSize: 100
    };
    getDictionaryListPageByDictNameAndDictCode(para).then(res => {
      this.runningDirectionList = res.data.data;
    });

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    //第一种写法，每个页面都需要写方法，但是可以做特性化处理
    // this.getButtonList(routers);
    
    //第二种写法，封装到 permissionRouter.js 中
    this.buttonList = getButtonList(this.$route.path, routers);
    this.operationButtonList = getOperationButtonList(this.$route.path, routers);
  }
}
</script>

<style scoped>

</style>
